<template>
  <div class="reward contents">
    <div class="list">
      <ul>
        <li>
          <router-link :to="toPath(dateArr[0].path)">
            <span class="title">이번달 적립 플레이 포인트</span>
            <span class="point">{{rewardInfo.thisMonthReward.addComma()}}</span>
            <span class="bt"><span>자세히보기</span><span class="icon iconMore5"></span></span>
          </router-link>
        </li>
        <li>
          <router-link :to="toPath(dateArr[1].path)">
            <span class="title">
              {{dateArr[1].month}}월 적립 플레이 포인트
              <span>| {{dateArr[0].month}}월 15일 지급</span>
            </span>
            <span class="point">{{rewardInfo.lastMonthReward.addComma()}}</span>
            <span class="bt"><span class="accessibilityHide">자세히보기</span><span class="icon iconMore2"></span></span>
          </router-link>
        </li>
        <li>
          <router-link :to="toPath(dateArr[2].path)">
            <span class="title">
              {{dateArr[2].month}}월 적립 플레이 포인트
              <span>| {{dateArr[1].month}}월 15일 지급</span>
            </span>
            <span class="point">{{rewardInfo.twoMonthsAgoReward.addComma()}}</span>
            <span class="bt"><span class="accessibilityHide">자세히보기</span><span class="icon iconMore2"></span></span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="banner">
      <router-link :to="{name: 'rewardIntro'}">
        <h3>리워드 프로그램이란?</h3>
        <p><strong>친구에게 상품 추천</strong>하고, <br> <strong>플레이포인트 적립</strong></p>
        <div class="bt">
          <span>자세히보기</span><span class="icon iconMore6"></span>
        </div>
      </router-link>
    </div>
    <div class="rewardInfo">
      <h3>리워드 프로그램 안내 사항</h3>
      <ul>
        <li>리워드 지급 대상 상품을 공유하고 상품을 공유 받은 친구가 쿠폰을 구매 후 사용해야 적립됩니다.​</li>
        <li>공유 상품당 한 명의 친구에게 적립 받을 수 있는 수량은 1개입니다. (한명이 여러 개를 구매해도 1개 금액에 대해서만 적립)​</li>
        <li>본인이 공유하고 본인이 구매하는 경우, 다른 친구가 구매했더라도 내가 사용하는 경우 포인트는 적립되지 않습니다. ​</li>
        <li>동일한 상품을 서로 공유하여 서로 적립 받은 포인트는 리워드 적립금액에서 제외됩니다. ​</li>
        <li>부적절한 방법으로 적립한 것이 확인 될 경우 사전안내 없이 적립된 포인트는 회수 될 수 있습니다.​</li>
        <li>적립 플레이 포인트는 다음날 오전 7시 이후에 반영됩니다.​</li>
        <li>이번 달 적립된 금액은 다음 달 15일 지급됩니다.​</li>
        <li>적립된 플레이포인트는 모바일 앱 넥슨플레이에서 확인하고, 넥슨캐시 쿠폰 등을 구매하는데 사용할 수 있습니다.​</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import mixin from '@/utils/mixin'

export default {
  mixins: [mixin],
  computed: {
    ...mapGetters('my', ['rewardInfo']),
    dateArr() {
      const result = [],
        now = new Date()
      let year = now.getFullYear(),
        month = now.getMonth() + 1,
        path
      for (let i = 0; i <= 2; i++) {
        if (month === 0) {
          month = 12
          year--
        }
        if (month < 10) {
          path = year + '0' + month
        } else {
          path = year + '' + month
        }
        result.push({ month, path })
        month--
      }
      return result
    }
  },
  methods: {
    ...mapActions('my', ['getRewardInfo']),
    toPath(path) {
      return { name: `${this.$route.name}View`, params: { rewardYearMonth: `${path}` }}
    },
  },
  mounted() {
    this.getRewardInfo()
  },
}
</script>

<style lang="scss">
.reward {
  .list {
    .title {
      display: block;
      font-size: 12px;
      line-height: 1.17;
      color: #151721;
      span {
        color: #8f8f96;
      }
    }
    .point {
      display: block;
      padding-top: 6px;
      font-size: 17px;
      font-weight: bold;
      line-height: 1.18;
      color: #151721;
    }
    .bt {
      position: absolute;
      top: 21px;
      right: 18px;
    }
    li {
      position: relative;
      height: 60px;
      padding: 10px 16px;
      border-bottom: 1px solid #d6d6e0;
      background-color: #fff;
    }
    li:first-child {
      height: 110px;
      padding: 25px 20px 0;
      margin: 10px;
      border-radius: 7px;
      background-color: #6134f1;
      border-bottom-width: 0;
      .title {
        color: #fff;
        font-size: 14px;
      }
      .title::before {
        content: "";
        display: inline-block;
        width: 16px;
        height: 16px;
        margin: 0 3px -3px 0;
        background: url("~@/assets/images/set_reward.svg") no-repeat 0 -75px;
        background-size: 53px auto;
      }
      .point {
        padding-top: 15px;
        font-size: 24px;
        font-weight: bold;
        color: #fff;
      }
      .bt {
        top: 60px;
        right: 20px;
        width: 89px;
        height: 25px;
        padding-top: 8px;
        font-size: 11px;
        text-align: center;
        line-height: 1.18;
        color: #6134f1;
        border-radius: 28px;
        background-color: #ffffff;
        .icon {
          margin-left: 5px;
        }
      }
    }
    li:not(:first-child) {
      .text {
        font-size: 200px;
      }
    }
  }
  .banner {
    a {
      position: relative;
      display: block;
      width: 100%;
      height: 85px;
      padding: 12px 0 0 16px;
      margin-top: 10px;
      background: #393a61;
      &::after {
        content: "";
        position: absolute;
        top: 13px;
        left: 170px;
        display: block;
        width: 53px;
        height: 61px;
        background: url("~@/assets/images/set_reward.svg") no-repeat 0 0;
        background-size: 53px auto;
      }
    }
    h3 {
      display: inline-block;
      height: 13px;
      margin: 0;
      font-size: 12px;
      font-weight: normal;
      color: #f0ebff;
      box-shadow: inset 0 -8px #4949a2;
    }
    p {
      padding-top: 7px;
      font-size: 14px;
      line-height: 1.41;
      color: #fff;
      strong {
        font-weight: normal;
        color: #34f193;
      }
    }
    .bt {
      position: absolute;
      top: 58px;
      right: 15px;
      font-size: 10px;
      line-height: 1.15;
      color: #f0ebff;
      .icon {
        margin: 1px 0 0 5px;
      }
    }
  }
}
@media all and (min-width: 500px) {
  .reward {
    .banner {
      a {
        padding-top: 22px;
        &::after {
          left: 300px;
        }
      }
      br {
        display: none;
      }
      .bt {
        top: 50px;
      }
    }
  }
}
.rewardInfo {
  padding: 0 16px;
  h3 {
    padding-top: 14px;
    margin: 0;
    font-size: 12px;
    font-weight: bold;
    line-height: 1.18;
    color: #57575c;
  }
  ul {
    padding-top: 9px;
    font-size: 11px;
    line-height: 1.5;
    text-align: left;
    color: #57575c;
  }
  li {
    padding: 0 0 7px 5px;
    text-indent: -5px;
    &::before {
      content: "";
      display: inline-block;
      width: 2px;
      height: 2px;
      margin: 0 3px 3px 0;
      border-radius: 50%;
      background-color: #57575c;
    }
  }
}
</style>
